import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const CardButtonText = styled.div<{ vertical?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${(props) => (props.vertical ? 150 : 250 * Screen.widthRatio)}px;
`;

export default CardButtonText;
